<section class="px-4 py-6 md:px-14 lg:px-[108px]" id="faq_container">

  <h3 id="faqs" class="text-purple_100 text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 text-center mb-10 lg:mb-16">
    Frequently Asked Questions(FAQ's)
  </h3>

  <div class="w-full max-w-4xl mx-auto">

    <div *ngFor="let faq of faqs; let i = index"
      class="w-full flex flex-col gap-4 mb-8 cursor-pointer border-b border-gray-100 pb-6 last:border-0">
      <div class="flex items-center justify-between gap-4" (click)="toggleAnswer(i)">

        <p class="text-hurrey-16 lg:text-hurrey-28 flex-1 font-medium hover:text-purple_100 transition-colors">
          {{ faq.question }}
        </p>

        <div class="flex-none flex justify-center items-center">
          <i-tabler name="chevron-down" class="custom-icon transition-transform duration-300"
            [ngClass]="{'rotate-180': faq.showAnswer}"></i-tabler>
        </div>

      </div>

      <div *ngIf="faq.showAnswer" [@expandOnEnter] [@collapseOnLeave]>
        <p class="text-base text-grey max-w-3xl leading-relaxed">
          {{ faq.answer }}
        </p>
      </div>

    </div>

  </div>

</section>